module.exports = __webpack_public_path__ + "img/数字化材料图书馆.862484c9.png";